'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CARD_TYPE = exports.CARD_TYPE = 'CARD';
var CARD_DISPLAY_NAME = exports.CARD_DISPLAY_NAME = 'Note';


//////////////////
// WEBPACK FOOTER
// ./src/common/cards/cardConstants.js
// module id = 111
// module chunks = 0